import React from 'react';
import '../../styles/streak-badge.css';

interface StreakBadgeProps {
    streakDays: number;
    todayXP?: number;
    compact?: boolean;
}

const StreakBadge: React.FC<StreakBadgeProps> = ({ streakDays, todayXP, compact = false }) => {
    if (compact) {
        return (
            <span className="streak-badge streak-badge--compact">
                🔥 {streakDays}
            </span>
        );
    }

    return (
        <div className="streak-badge streak-badge--full">
            <span className="streak-badge__flame">🔥 {streakDays} day streak</span>
            {todayXP !== undefined && todayXP > 0 && (
                <span className="streak-badge__xp">⚡ {todayXP} XP today</span>
            )}
        </div>
    );
};

export default StreakBadge;
